/* eslint-disable camelcase, @typescript-eslint/naming-convention */
// Card → issue-type mapping for per-check exclusions (IP-14862).
//
// Each Issue Configuration card on the settings page is a tenant-level enable
// FLAG, not a single detection issue type. A card can gate SEVERAL
// InspectionManager::IssueTypeEnum values (see app/services/agents/
// inspection_manager.rb#flag_disabled_issue_types). An exclusion for a card
// therefore fans out to one ia_check_config (enabled:false) row per issue type
// the card covers, for each selected scope value.
//
// Cards whose issueTypes list is empty ('office_only', 'require_issue_resolution',
// 'photo_analysis') are pure behaviour flags with no detection issue type — they
// cannot carry ia_check_config exclusions and do not render the Add Exclusion
// affordance.
// InspectionManager::IssueTypeEnum values (verified against
// app/models/concerns/inspection_manager/issue_type_enum.rb).
export const ISSUE_TYPE = {
    unanswered_questions: 0,
    missing_signatures: 1,
    missing_deficiency_notes_photos: 2,
    missing_time_entries: 3,
    out_of_spec_values: 5,
    analyze_deficiency_notes: 6,
    inspection_timing_audit: 8,
    asset_count_change: 10,
    drifting_values: 11,
    ulc_reference_clause_check: 12
};
export const CHECK_CARDS = [
    {
        key: 'aiInspectionManagerGrammarAndStyleEnabled',
        titleKey: 'grammar_and_style_title',
        descriptionKey: 'grammar_and_style_description',
        defaultValue: true,
        issueTypes: [ISSUE_TYPE.analyze_deficiency_notes]
    },
    {
        key: 'aiInspectionManagerMissingInformationEnabled',
        titleKey: 'missing_information_title',
        descriptionKey: 'missing_information_description',
        defaultValue: true,
        issueTypes: [
            ISSUE_TYPE.missing_signatures,
            ISSUE_TYPE.missing_deficiency_notes_photos,
            ISSUE_TYPE.missing_time_entries
        ]
    },
    {
        key: 'aiInspectionManagerOfficeOnlyEnabled',
        titleKey: 'office_only_title',
        descriptionKey: 'office_only_description',
        defaultValue: true,
        issueTypes: []
    },
    {
        key: 'aiInspectionManagerPhotoAnalysisEnabled',
        titleKey: 'photo_analysis_title',
        descriptionKey: 'photo_analysis_description',
        defaultValue: false,
        issueTypes: []
    },
    {
        key: 'aiInspectionManagerNeedsCorrectionEnabled',
        titleKey: 'needs_correction_title',
        descriptionKey: 'needs_correction_description',
        defaultValue: true,
        issueTypes: [
            ISSUE_TYPE.out_of_spec_values,
            ISSUE_TYPE.inspection_timing_audit,
            ISSUE_TYPE.asset_count_change,
            ISSUE_TYPE.drifting_values,
            ISSUE_TYPE.ulc_reference_clause_check
        ]
    },
    {
        key: 'aiInspectionManagerUnansweredQuestionsEnabled',
        titleKey: 'unanswered_questions_title',
        descriptionKey: 'unanswered_questions_description',
        defaultValue: true,
        issueTypes: [ISSUE_TYPE.unanswered_questions]
    },
    {
        key: 'aiInspectionManagerRequireIssueResolutionEnabled',
        titleKey: 'require_issue_resolution_title',
        descriptionKey: 'require_issue_resolution_description',
        defaultValue: false,
        issueTypes: []
    }
];
// The "Exclude by" axis choices, in the design's order.
export const EXCLUSION_SCOPE_LEVELS = ['account', 'account_tag', 'building', 'building_tag'];
